import React from "react";

export const LicenseRenewalContainerContext = React.createContext();